<template>
<div class="container">
  <div class="row">
    <span>Requisição</span>
    <h3>{{workflow.name}}</h3>
    <h5 v-if="workflow.customizations.mailContact">Caso haja dúvidas entrar em contato com o e-mail <a :href="'mailto:' + workflow.customizations.mailContact">{{workflow.customizations.mailContact}}</a>.</h5>
    <button v-if="showRequestsButton" @click="seeRequests" class="btn btn-success"><span class="glyphicon glyphicon-eye-open"></span> Ver Requisições Associadas</button>
    <hr>
    <div class="panel panel-default">
      <div class="panel-body">
        <div v-html="workflow.description"></div>
      </div>
    </div>
    <hr>
    <div v-show="loading">
      <loader></loader>
    </div>
    <steps :steps="steps" :editable=false :icons=false :groups="[]"></steps>
    <br>
    <div v-show="!loading">
      <div v-show="sections.length > 0">
        <form v-show="currentFormFields.length > 0">
          <div v-for="(fields, sectionId, i) in summary" :key="sectionId" v-if="showSummary" class="panel panel-default">
            <div class="panel-heading"><h4>{{ i + 1 }}. {{getSection(sectionId).name}}</h4></div>
            <div class="panel-body">
              <div class="form-group" v-for="formField in fields" v-bind:key="formField.objectId">
                <label :for="formField.objectId" class="control-label" v-if="formField.type !== 'separator'">
                  {{ formField.name }}<span v-if="formField.required" class="required"> *</span>
                </label>
                <p class="text-muted field-desc" v-if="formField.description" v-html="formField.description"></p>
                <dynamic-form-field :formField='formField' :showSummary='true'></dynamic-form-field>
              </div>
            </div>
          </div>
          <div class="panel panel-default" id="form-fields" v-if="!showSummary">
            <div class="panel-body">
              <div class="form-group" v-bind:class="{ 'has-error': formField.invalid }" v-for="formField in currentFormFields" v-bind:key="formField.objectId">
                <label :for="formField.objectId" class="control-label" v-if="formField.type !== 'separator'">
                  {{ formField.name }}<span v-if="formField.required" class="required"> *</span> <span v-if="formField.type === 'file' && formField.type === 'document'" class="upload-limit">(tamanho máx. 50mb)</span>
                </label>
                <h3 v-else>{{ formField.name }}</h3>
                <p class="text-muted field-desc" v-if="formField.description" v-html="formField.description"></p>
                <dynamic-form-field :formField='formField' :showSummary='showSummary' :onChange='onChange'>
                </dynamic-form-field>
                <span class="help-block" v-show="formField.invalid">O campo deve ser preenchido corretamente</span>
              </div>
              <!-- <button v-if="canAddRepeated" type="button" class="btn btn-default" @click="repeat">
                Adicionar <span class="glyphicon glyphicon-plus"></span>
              </button> -->
            </div>
          </div>
        </form>
        <button @click="back" class="btn btn-default"><span class="glyphicon glyphicon-chevron-left"></span> Voltar</button>
        <button v-if="showSummary === false" type="button" class="btn btn-primary" @click="next" :disabled="!canReachNext">Próximo <span class="glyphicon glyphicon-chevron-right"></span></button>
        <button v-else type="button" id="btn-open-request" class="btn btn-success" @click="saveRequest">Finalizar <span class="glyphicon glyphicon-ok"></span></button>
        <div v-show="!fieldsInstances.length">
          <p class="alert alert-danger">O Tipo de Requisição escolhido ainda não possui campos para preenchimento.</p>
          <button @click="back" class="btn btn-default">Voltar</button>
        </div>
      </div>
      <div v-show="!sections.length">
        <p class="alert alert-danger">O Tipo de Requisição escolhido ainda não possui seções.</p>
        <button @click="back" class="btn btn-default">Voltar</button>
      </div>
    </div>
  </div>
  <modal name="ask-repeat" :height="'auto'">
    <div class="modal-container">
      <h3>Deseja continuar adicionando informações sobre {{currentSection() ? currentSection().name : ''}}?</h3>
      <div style="margin-top: 25px;">
        <button class="btn btn-primary" @click="answerRepeat(true)">Sim</button>
        <button class="btn btn-default" @click="answerRepeat(false)">Não, ir para próxima seção.</button>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
  
  import {
    Parse,
    miniToastr,
    computeValue,
    createParseFile
  } from '../Global'

  import Loader from './util/Loader'
  import moment from 'moment'
  import Steps from './util/Steps'
  import DynamicFormField from './util/DynamicFormField'
  import { handleParseError } from './util/ErrorHandling'
  
  moment.locale('pt-br')

  var FormField = Parse.Object.extend('FormField')
  var RequestType = Parse.Object.extend('RequestType')
  var FormFieldRule = Parse.Object.extend('FormFieldRule')

  export default {
    components: {
      Loader,
      Steps,
      DynamicFormField
    },
    data () {
      return {
        loading: false,
        saved: false,
        workflow: {reqType: {}},
        fieldsInstances: [],
        allFormFields: [],
        allFieldsInstances: [],
        sectionStack: [],
        sections: [],
        showSummary: false,
        showRequestsButton: false,
        rules: [],
        repeatQuestion: {
          asked: false,
          answer: false
        }
      }
    },
    mounted () {
      this.workflowId = this.$route.params.workflowId
      this.load(this.workflowId)
    },
    methods: {
      onChange (formField, event) {
        if (formField.type === 'file') {
          createParseFile(formField, event)
        }
        formField.invalid = !this.formFieldIsValid(formField)
      },
      load (id) {
        this.loading = true
        let self = this
        let Workflow = Parse.Object.extend('Workflow')
        let queryWorkflow = new Parse.Query(Workflow)
        queryWorkflow.include('reqType')
        queryWorkflow.get(id).then((obj) => {
          self.workflow = obj.toJSON()
          return self.getFormFieldsAndSections(self.workflow.reqType.objectId)
        }).then(() => {
          self.loading = false
          return self.checkShowRequestsButton()
        }).fail(error => {
          handleParseError(self, error)
          self.loading = false
        })
      },
      back () {
        if (this.showSummary) {
          this.showSummary = false
        } else if (this.sectionStack.length > 1) {
          this.allFieldsInstances = this.allFieldsInstances.filter(f => f.sectionOrder !== this.sectionStack.length)
          this.sectionStack.pop()
          this.fieldsInstances = this.allFieldsInstances.filter(f => f.sectionOrder === this.sectionStack.length)
        } else {
          this.$router.push('/openRequest')
        }
      },
      repeat () {
        let self = this
        if (!self.validateFields()) {
          miniToastr.warn('Alguns itens não foram preenchidos corretamente. Corrija-os')
        } else {
          self.sectionStack.push(self.currentSection())
          self.loadSectionFields()
        }
      },
      answerRepeat (answer) {
        this.repeatQuestion = {'asked': true, 'answer': answer}
        this.next()
        this.$modal.hide('ask-repeat')
      },
      next () {
        let self = this
        if (self.sectionStack.length === 0) {
          self.sectionStack.push(self.sections[0])
          self.loadSectionFields()
        } else {
          let currentSection = self.currentSection()
          if (!self.validateFields()) {
            miniToastr.warn('Alguns itens não foram preenchidos corretamente. Corrija-os')
          } else {
            let action = currentSection.action
            let nextSectionByRule = self.checkAppliedRules()
            var waitingForQuestion = false
            if (nextSectionByRule !== undefined) {
              self.sectionStack.push(nextSectionByRule)
            } else if (!this.repeatQuestion.asked && this.canAddRepeated) {
              this.$modal.show('ask-repeat')
              waitingForQuestion = true
            } else if (this.repeatQuestion.asked && this.repeatQuestion.answer) {
              this.repeat()
            } else if (action === 'next') {
              let currentIndex = self.sections.findIndex(s => s.objectId === currentSection.objectId)
              self.sectionStack.push(self.sections[currentIndex + 1])
            } else if (action === 'goto') {
              self.sectionStack.push(self.sections.find(s => s.objectId === currentSection.goto.objectId))
            } else {
              self.showSummary = true
            }

            if (!waitingForQuestion && self.showSummary === false && !this.repeatQuestion.answer) {
              self.loadSectionFields()
            }
            this.repeatQuestion.asked = false
            this.repeatQuestion.answer = false
          }
        }
        self.scrollTo(document.body, 0, 100)
      },
      checkAppliedRules () {
        let self = this
        let rulesThatCouldApply = self.rules.filter(r => self.fieldsInstances.find(f => f.objectId === r.formField.objectId) !== undefined)
        let nextSection
        rulesThatCouldApply.forEach(rule => {
          if (rule.operation === 'equals') {
            let formField = self.fieldsInstances.find(field => field.objectId === rule.formField.objectId)
            if (formField) {
              let ruleApplies = formField.type === 'select' && formField.value.code === rule.argument ||
                                formField.type === 'number' && (formField.value + '') === rule.argument ||
                                formField.value === rule.argument
              if (ruleApplies) {
                nextSection = self.sections.find(section => section.objectId === rule.goto.objectId)
              }
            }
          }
        })
        return nextSection
      },
      getSubmissionFormFields () {
        let self = this
        // Fields filtrados pelos que possuem alguma seção na stack
        return self.allFieldsInstances.filter(f => self.sectionStack.find(s => s.objectId === f.section.objectId) !== undefined)
      },
      validateFields () {
        let self = this
        let invalids = self.fieldsInstances.filter(f => {
          f.invalid = !self.formFieldIsValid(f)
          return f.invalid
        })
        return invalids.length === 0
      },
      loadSectionFields () {
        let self = this
        let newCurrentSection = self.currentSection()
        self.fieldsInstances = self.allFormFields.filter(f => f.section.objectId === newCurrentSection.objectId)
                                                  .map(f => { f.sectionOrder = self.sectionStack.length; return f })
                                                  .map(f => JSON.parse(JSON.stringify(f)))
        self.fieldsInstances.forEach(f => {
          self.$watch(() => f.value, self.computedFields)
        })
        this.allFieldsInstances = this.allFieldsInstances.concat(this.fieldsInstances)
      },
      currentSection () {
        let self = this
        return self.sectionStack.length ? self.sectionStack[self.sectionStack.length - 1] : undefined
      },
      getSection (objectId) {
        return this.sectionStack.find(s => s.objectId === objectId) || {}
      },
      getFormFieldsAndSections (id) {
        let query = new Parse.Query(FormField)
        let reqType = new RequestType()
        reqType.id = id
        query.ascending('order')
        query.limit(1000)
        query.equalTo('reqType', reqType)
        let self = this
        let data = {}
        return query.find().then(results => {
          data.allFormFieldsParse = results
          self.allFormFields = results.map(r => {
            let item = r.toJSON()
            item.invalid = false
            item.value = item.type === 'checkbox' ? [] : null
            item.dateValue = null
            item.filename = null
            return item
          })
          return Parse.Cloud.run('listFormSections', {requestId: reqType.id})
        }).then(results => {
          self.sections = results.data.map(r => r.toJSON())
          let queryRules = new Parse.Query(FormFieldRule)
          queryRules.containedIn('formField', data.allFormFieldsParse)
          return queryRules.find()
        }).then(results => {
          self.rules = results.map(r => r.toJSON())
          self.next()
        })
      },
      formFieldIsValid (field) {
        let valid = true
        if (field.type === 'date' && field.required && !moment(field.dateValue, 'DD/MM/YYYY').isValid()) {
          valid = false
        } else if (field.required && !field.value && field.type !== 'date') {
          valid = false
        }
        return valid
      },
      saveRequestOnCloud () {
        let self = this
        self.allFieldsInstances.forEach(f => {
          f.originalId = f.objectId
        })
        let params = {
          reqTypeId: self.workflow.reqType.objectId,
          workflowId: self.workflow.objectId,
          allFieldsInstances: self.allFieldsInstances
        }
        self.loading = true
        Parse.Cloud.run('openRequest', params).then((res) => {
          self.loading = false
          self.$router.push('/requestConfirmation/' + res.requestId)
          miniToastr.success('Requisição aberta com sucesso.')
        }, (error) => {
          self.loading = false
          handleParseError(self, error)
        })
      },
      saveRequest () {
        let self = this
        self.loading = true
        if (!self.validateFields()) {
          miniToastr.warn('Alguns itens não foram preenchidos corretamente. Corrija-os')
          self.loading = false
          return
        }
        self.getSubmissionFormFields().filter(f => f.type === 'date').forEach(f => {
          f.value = f.dateValue ? moment(f.dateValue, 'DD/MM/YYYY').toDate() : undefined
        })
        self.getSubmissionFormFields().filter(f => f.type === 'money').forEach(f => {
          f.value = parseFloat(f.value)
        })
        let promises = self.getSubmissionFormFields().filter(f => (f.type === 'file' || f.type === 'document') && f.value).map(f => {
          return f.value.save()
        })
        if (promises.length > 0) {
          Parse.Promise.when(promises).then(results => {
            self.saveRequestOnCloud()
          }).fail(errors => {
            self.loading = false
            let error = errors[0]
            handleParseError(self, error)
          })
        } else {
          self.saveRequestOnCloud()
        }
      },
      seeRequests () {
        this.$router.push('/workflow/' + this.workflow.objectId + '/requests')
      },
      checkShowRequestsButton () {
        let self = this
        var responsibleId = this.workflow.responsible.objectId
        Parse.Cloud.run('enableLinkedRequestButton', { responsibleId }).then(response => {
          self.showRequestsButton = response.showRequestsButton
        })
      },
      computedFields () {
        let self = this
        const computed = self.fieldsInstances.filter(f => f.type === 'computed')
        computed.forEach(computedField => {
          const formula = computedField.formula
          computedField.value = computeValue(formula, self.fieldsInstances)
        })
      },
      scrollTo (element, to, duration) {
        let self = this
        if (duration < 0) return
        let difference = to - element.scrollTop
        let perTick = difference / duration * 2
        setTimeout(() => {
          element.scrollTop = element.scrollTop + perTick
          self.scrollTo(element, to, duration - 2)
        }, 10)
      }
    },
    computed: {
      currentFormFields () {
        let self = this
        if (self.showSummary) {
          return self.getSubmissionFormFields()
        } else {
          return self.fieldsInstances
        }
      },
      steps () {
        let self = this
        let steps = JSON.parse(JSON.stringify(self.sectionStack))
        if (self.showSummary) {
          steps.push({name: 'Resumo', description: 'Confira seus dados antes de finalizar'})
        }
        if (steps.length) {
          steps[steps.length - 1].active = true
        }
        return steps
      },
      canAddRepeated () {
        return this.showSummary === false &&
          this.repeatedInfo.active &&
          this.repeatedInfo.total + 1 <= this.repeatedInfo.max
      },
      canReachNext () {
        if (this.repeatedInfo && this.repeatedInfo.active) {
          return this.repeatedInfo.total >= this.repeatedInfo.min || this.repeatedInfo.min === undefined
        }
        return true
      },
      repeatedInfo () {
        let self = this
        let info = { active: false }
        let current = self.currentSection()
        if (current && current.repeat && current.repeat.active) {
          info = current.repeat
          info.total = 0
          for (let i = self.sectionStack.length - 1; i >= 0; i--) {
            let item = self.sectionStack[i]
            if (item.objectId === current.objectId) {
              info.total++
            } else {
              break
            }
          }
        }
        return info
      },
      summary () {
        let groups = {}
        this.getSubmissionFormFields().forEach(item => {
          let list = groups[item.section.objectId]
          if (list) {
            list.push(item)
          } else {
            groups[item.section.objectId] = [item]
          }
        })
        return groups
      },
      updateComputedFields () {
      }
    }
  }

</script>

<style scoped>
.field-date {
    background-color: white !important;
}
.required {
  color: red;
}

.field-label {
  margin-bottom: 0px;
}

.field-desc {
  font-size: 0.85em;
}
.upload-limit {
  color: #af5858;
  font-size: 0.8em;
}
.modal-container {
  padding-bottom: 25px;
  padding-left: 25px;
}
</style>



// WEBPACK FOOTER //
// RequestForm.vue?631771af